(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["business-plan-generator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-business-plan-generator]');

    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const locale = document.documentElement.lang || 'fr';
      const translations = JSON.parse(root.querySelector('[data-bp-translations]').textContent);
      const tr = (key, ...values) => translations[key].replace(/\{(\d+)\}/g, (_, index) => String(values[Number(index)] ?? ''));
      const form = root.querySelector('[data-bp-form]');
      const report = root.querySelector('[data-report]');
      const loading = root.querySelector('[data-loading]');
      const message = root.querySelector('[data-form-message]');
      const progressBar = root.querySelector('[data-progress-bar]');
      const progressLabel = root.querySelector('[data-progress-label]');
      const fields = Array.from(form.querySelectorAll('input[required], select[required]'));
      let reportTimer;

      const money = (value) => new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0
      }).format(value);

      const sentenceList = (items) => new Intl.ListFormat(locale, { style: 'long', type: 'conjunction' }).format(items);

      const updateProgress = () => {
        let completed = 0;
        const grouped = ['model'];

        fields.forEach((field) => {
          if (field.type === 'radio') return;
          if (String(field.value || '').trim() !== '') completed += 1;
        });

        grouped.forEach((name) => {
          if (form.querySelector(`input[name="${name}"]:checked`)) completed += 1;
        });

        const categoryCount = form.querySelectorAll('input[name="categories"]:checked').length;
        if (categoryCount >= 2) completed += 1;

        const total = fields.filter((field) => field.type !== 'radio').length + grouped.length + 1;
        const percent = Math.min(100, Math.round((completed / total) * 100));
        progressBar.style.width = `${percent}%`;
        progressLabel.textContent = `${percent} %`;
        root.querySelector('[data-progress]').setAttribute('aria-valuenow', String(percent));
      };

      form.addEventListener('input', updateProgress);
      form.addEventListener('change', updateProgress);

      form.addEventListener('reset', () => {
        clearTimeout(reportTimer);
        loading.hidden = true;
        setTimeout(() => {
          updateProgress();
          report.hidden = true;
          message.textContent = '';
          form.querySelector('input').focus();
        }, 0);
      });

      root.querySelector('[data-print]').addEventListener('click', () => {
        const projectTitle = root.querySelector('[data-r-project]')?.textContent?.trim() || 'Business plan';
        const printWindow = window.open('', '_blank', 'width=1000,height=800');

        if (!printWindow) {
          window.alert(tr('j_fc067fa5a1'));
          return;
        }

        const styles = getComputedStyle(root);
        const accent = styles.getPropertyValue('--bp-accent').trim() || '#4e5f45';
        const accentContrast = styles.getPropertyValue('--bp-accent-contrast').trim() || '#ffffff';
        const soft = styles.getPropertyValue('--bp-soft').trim() || '#f4f1ea';
        const border = styles.getPropertyValue('--bp-border').trim() || '#d9d4ca';
        const textColor = styles.getPropertyValue('--bp-text').trim() || '#242424';

        const reportClone = report.cloneNode(true);
        reportClone.hidden = false;
        reportClone.querySelectorAll('.es-bp__report-actions').forEach((element) => element.remove());

        const safeTitle = projectTitle.replace(/[<>&"]/g, (character) => ({
          '<': '&lt;',
          '>': '&gt;',
          '&': '&amp;',
          '"': '&quot;'
        })[character]);

        printWindow.document.open();
        printWindow.document.write(`
          <!doctype html>
          <html lang="${locale}">
            <head>
              <meta charset="utf-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <title>${safeTitle} - Business plan</title>
              <style>
                @page {
                  size: A4;
                  margin: 16mm 15mm 18mm;
                }

                * {
                  box-sizing: border-box;
                }

                html,
                body {
                  margin: 0;
                  padding: 0;
                  background: #ffffff;
                  color: ${textColor};
                  font-family: Arial, Helvetica, sans-serif;
                  font-size: 10.5pt;
                  line-height: 1.5;
                }

                body {
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }

                .es-bp__report {
                  width: 100%;
                  margin: 0;
                  padding: 0;
                }

                .es-bp__report-cover {
                  min-height: 225mm;
                  padding: 24mm 18mm;
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  border-radius: 0;
                  background: ${accent};
                  color: ${accentContrast};
                  break-after: page;
                  page-break-after: always;
                }

                .es-bp__report-cover > p {
                  margin: 0 0 auto;
                  font-size: 9pt;
                  font-weight: 700;
                  letter-spacing: .16em;
                  text-transform: uppercase;
                }

                .es-bp__report-cover .es-brand{margin:6mm 0 0;font-size:11pt;opacity:.9;}
                .es-bp__report-cover h2 {
                  max-width: 165mm;
                  margin: 0;
                  font-family: Georgia, "Times New Roman", serif;
                  font-size: 36pt;
                  line-height: 1;
                  letter-spacing: -.025em;
                }

                .es-bp__report-meta {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 5mm;
                  margin-top: 8mm;
                  font-size: 9pt;
                  opacity: .82;
                }

                .es-bp__report-summary {
                  display: grid;
                  grid-template-columns: repeat(2, 1fr);
                  margin: 0 0 10mm;
                  border: 1px solid ${border};
                  border-radius: 4mm;
                  overflow: hidden;
                  break-inside: avoid;
                }

                .es-bp__report-summary > div {
                  min-height: 30mm;
                  padding: 6mm;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  background: ${soft};
                  border-right: 1px solid ${border};
                  border-bottom: 1px solid ${border};
                }

                .es-bp__report-summary > div:nth-child(2n) {
                  border-right: 0;
                }

                .es-bp__report-summary > div:nth-last-child(-n+2) {
                  border-bottom: 0;
                }

                .es-bp__report-summary span {
                  font-size: 8pt;
                  opacity: .68;
                }

                .es-bp__report-summary strong {
                  margin-top: 4mm;
                  font-family: Georgia, "Times New Roman", serif;
                  font-size: 18pt;
                }

                .es-bp__report-section {
                  display: grid;
                  grid-template-columns: 12mm minmax(0, 1fr);
                  gap: 5mm;
                  padding: 10mm 0;
                  border-bottom: 1px solid ${border};
                  break-inside: auto;
                }

                .es-bp__report-section:first-of-type {
                  padding-top: 2mm;
                }

                .es-bp__report-number {
                  margin: 1mm 0 0;
                  font-size: 8pt;
                  font-weight: 700;
                  letter-spacing: .12em;
                  opacity: .52;
                }

                .es-bp__report-section h3 {
                  margin: 0 0 5mm;
                  font-family: Georgia, "Times New Roman", serif;
                  font-size: 23pt;
                  line-height: 1.05;
                }

                .es-bp__report-section p {
                  margin: 0;
                  line-height: 1.65;
                }

                .es-bp__tags {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 2mm;
                  margin-top: 5mm;
                }

                .es-bp__tags span {
                  padding: 2mm 3mm;
                  border-radius: 20mm;
                  background: ${soft};
                  font-size: 8pt;
                }

                .es-bp__budget-bars {
                  display: grid;
                  gap: 4mm;
                }

                .es-bp__budget-bars > div {
                  display: grid;
                  grid-template-columns: 48mm minmax(0, 1fr) 12mm;
                  gap: 4mm;
                  align-items: center;
                  break-inside: avoid;
                }

                .es-bp__budget-bars i {
                  height: 3mm;
                  overflow: hidden;
                  border-radius: 20mm;
                  background: #e8e8e8;
                }

                .es-bp__budget-bars b {
                  display: block;
                  height: 100%;
                  background: ${accent};
                }

                .es-bp__caption {
                  margin-top: 5mm !important;
                  font-size: 8pt;
                  opacity: .62;
                }

                .es-bp__strategy-grid,
                .es-bp__swot {
                  display: grid;
                  grid-template-columns: repeat(2, minmax(0, 1fr));
                  gap: 4mm;
                  margin-top: 5mm;
                }

                .es-bp__strategy-grid > div,
                .es-bp__swot > div {
                  padding: 6mm;
                  border-radius: 4mm;
                  background: ${soft};
                  break-inside: avoid;
                }

                .es-bp__strategy-grid p {
                  margin-top: 3mm;
                }

                .es-bp__swot span {
                  display: block;
                  margin-bottom: 3mm;
                  font-weight: 700;
                }

                .es-bp__swot ul {
                  margin: 0;
                  padding-left: 5mm;
                }

                .es-bp__swot li {
                  margin: 2mm 0;
                }

                .es-bp__timeline {
                  margin: 0;
                  padding: 0;
                  list-style: none;
                  counter-reset: bpMonth;
                }

                .es-bp__timeline li {
                  counter-increment: bpMonth;
                  position: relative;
                  padding: 0 0 7mm 12mm;
                  border-left: 1px solid ${border};
                  break-inside: avoid;
                }

                .es-bp__timeline li:last-child {
                  border-left-color: transparent;
                }

                .es-bp__timeline li::before {
                  content: counter(bpMonth);
                  position: absolute;
                  left: -4.5mm;
                  top: 0;
                  width: 9mm;
                  height: 9mm;
                  display: grid;
                  place-items: center;
                  border-radius: 50%;
                  background: ${accent};
                  color: ${accentContrast};
                  font-size: 7.5pt;
                  font-weight: 700;
                }

                .es-bp__timeline strong {
                  display: block;
                  margin-bottom: 1mm;
                }

                .es-bp__timeline p {
                  opacity: .75;
                }

                .es-bp__disclaimer {
                  margin-top: 9mm;
                  padding: 6mm;
                  border-left: 1.2mm solid ${accent};
                  background: ${soft};
                  break-inside: avoid;
                }

                .es-bp__disclaimer p {
                  margin: 2mm 0 0;
                  opacity: .76;
                }

                [hidden] {
                  display: none !important;
                }

                @media print {
                  html,
                  body {
                    width: 210mm;
                  }

                  a {
                    color: inherit;
                    text-decoration: none;
                  }
                }
              </style>
            </head>
            <body>
              ${reportClone.outerHTML.replace('</h2>','</h2><p class="es-brand">ESOTERICAE.COM</p>').replace('</body>','')}
              \x3Cscript>
                window.addEventListener('load', () => {
                  setTimeout(() => {
                    window.focus();
                    window.print();
                  }, 250);
                });

                window.addEventListener('afterprint', () => {
                  window.close();
                });
              \x3C/script>
            </body>
          </html>
        `);
        printWindow.document.close();
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const categories = Array.from(form.querySelectorAll('input[name="categories"]:checked')).map((input) => input.value);
        if (!form.checkValidity()) {
          form.reportValidity();
          message.textContent = tr('j_9c52ac9e11');
          return;
        }
        if (categories.length < 2) {
          message.textContent = tr('j_5e351a04bf');
          return;
        }

        message.textContent = '';
        report.hidden = true;
        loading.hidden = false;

        const data = Object.fromEntries(new FormData(form).entries());
        data.categories = categories;
        const label = (text) => locale.startsWith('fr') ? text.toLowerCase() : text;
        data.categoryLabels = Array.from(form.querySelectorAll('input[name="categories"]:checked')).map((input) => label(input.closest('label').querySelector('span').textContent.trim()));
        data.audienceLabel = label(form.querySelector('[name="audience"]').selectedOptions[0].textContent.trim());
        data.budget = Number(data.budget);
        data.basket = Number(data.basket);
        data.launch = Number(data.launch);

        clearTimeout(reportTimer);
        reportTimer = setTimeout(() => {
          generateReport(data);
          loading.hidden = true;
          report.hidden = false;
          report.focus({ preventScroll: true });
          report.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }, 900);
      });

      const generateReport = (data) => {
        const modelLabels = {
          'physique': tr('j_418283bb5f'),
          'en ligne': tr('j_cb9e3d97ee'),
          'omnicanale': tr('j_78d857afff')
        };

        const model = modelLabels[data.model];
        const stockPct = data.model === 'en ligne' ? 48 : data.model === 'physique' ? 42 : 44;
        const installPct = data.model === 'en ligne' ? 18 : data.model === 'physique' ? 30 : 26;
        const marketingPct = data.model === 'en ligne' ? 18 : 12;
        const cashPct = 100 - stockPct - installPct - marketingPct;

        const stockBudget = Math.round(data.budget * stockPct / 100);
        const avgCostPerReference = data.categories.includes('cristaux et minéraux') ? 42 : 34;
        const references = Math.max(45, Math.round(stockBudget / avgCostPerReference));
        const stockRangeLow = Math.max(35, Math.round(references * .85));
        const stockRangeHigh = Math.round(references * 1.15);

        const monthlyOrders = data.model === 'physique'
          ? Math.max(70, Math.round(data.budget / 130))
          : data.model === 'en ligne'
            ? Math.max(55, Math.round(data.budget / 155))
            : Math.max(85, Math.round(data.budget / 120));

        const monthlyRevenue = monthlyOrders * data.basket;

        root.querySelector('[data-r-project]').textContent = data.projectName;
        root.querySelector('[data-r-model]').textContent = model;
        root.querySelector('[data-r-location]').textContent = data.location;
        root.querySelector('[data-r-budget]').textContent = money(data.budget);
        root.querySelector('[data-r-stock]').textContent = money(stockBudget);
        root.querySelector('[data-r-references]').textContent = tr('range', stockRangeLow, stockRangeHigh);
        root.querySelector('[data-r-revenue]').textContent = money(monthlyRevenue);

        const modelText = data.model === 'physique'
          ? tr('j_e021c57a22', data.location)
          : data.model === 'en ligne'
            ? tr('j_fd6adbdc4f', data.location)
            : tr('j_bdce83a95f', data.location);

        root.querySelector('[data-r-presentation]').textContent =
          tr('j_0901b8f0b5', data.projectName, (locale.startsWith('de') ? model : model.toLowerCase()), data.audienceLabel, modelText, money(data.budget));

        const positionText = data.audience === 'débutants et curieux'
          ? tr('j_fe32293a79')
          : data.audience === 'pratiquants réguliers'
            ? tr('j_734b95804b')
            : data.audience === 'collectionneurs et passionnés'
              ? tr('j_b5264188e8')
              : data.audience === 'clientèle cadeau et bien-être'
                ? tr('j_18ba3f7866')
                : tr('j_ff670f4203');

        root.querySelector('[data-r-positioning]').textContent =
          tr('j_f74683dae6', positionText, sentenceList(data.categoryLabels));

        const tagBox = root.querySelector('[data-r-categories]');
        tagBox.innerHTML = '';
        data.categories.forEach((category) => {
          const tag = document.createElement('span');
          tag.textContent = data.categoryLabels[data.categories.indexOf(category)];
          tagBox.appendChild(tag);
        });

        const budgetParts = {
          stock: stockPct,
          install: installPct,
          marketing: marketingPct,
          cash: cashPct
        };

        Object.entries(budgetParts).forEach(([key, value]) => {
          root.querySelector(`[data-bar-${key}]`).style.width = `${value}%`;
          root.querySelector(`[data-pct-${key}]`).textContent = `${value} %`;
        });

        root.querySelector('[data-r-audience]').textContent =
          tr('j_56350d6859', data.audienceLabel);

        const acquisition = data.model === 'physique'
          ? tr('j_e70f204d0d')
          : data.model === 'en ligne'
            ? tr('j_9d287cd2d2')
            : tr('j_3d9c8fe798');

        root.querySelector('[data-r-acquisition]').textContent = acquisition;
        root.querySelector('[data-r-basket]').textContent =
          tr('j_fce1b6e625', money(data.basket));

        const strengths = [
          tr('j_f4983c2446', sentenceList(data.categoryLabels.slice(0, 3))),
          data.model === 'en ligne' ? tr('j_c3933c2557') : tr('j_d2f454ad20'),
          tr('j_e01d3828b0', money(data.basket)),
          data.experience === 'déjà commerçant' || data.experience === 'expérimenté dans le commerce'
            ? tr('j_8a5484b019')
            : tr('j_c0a68622a5')
        ];

        const risks = [
          data.budget <= 7500 ? tr('j_2671b6d446') : tr('j_86b25e2183'),
          data.model === 'physique' ? tr('j_e67c92a4a7') : tr('j_8f35c8a3d9'),
          tr('j_020bbf1622'),
          data.launch <= 3 ? tr('j_347e8e5c2f') : tr('j_6303d1d5e0')
        ];

        const fillList = (selector, items) => {
          const list = root.querySelector(selector);
          list.innerHTML = '';
          items.forEach((item) => {
            const li = document.createElement('li');
            li.textContent = item;
            list.appendChild(li);
          });
        };

        fillList('[data-r-strengths]', strengths);
        fillList('[data-r-risks]', risks);

        const timeline = [
          [tr('j_c9795be4e7'), tr('j_9767552c6c')],
          [tr('j_6d3b00c2e0'), tr('j_a275ad237f')],
          [tr('j_654495d636'), tr('j_4039dfc3d1', stockRangeLow, stockRangeHigh)],
          [tr('j_c077ab7100'), tr('j_10a61a02be')],
          [tr('j_bb2e2bc23f'), tr('j_2db4d9d11c')],
          [tr('j_1fdadf9264'), tr('j_0cf63e014e')]
        ];

        const timelineEl = root.querySelector('[data-r-timeline]');
        timelineEl.innerHTML = '';
        timeline.forEach(([title, text]) => {
          const li = document.createElement('li');
          li.innerHTML = `<strong>${title}</strong><p>${text}</p>`;
          timelineEl.appendChild(li);
        });
      };

      updateProgress();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
